(function () {

    const handleOnClick = ( event ) => {
        const container = event.target.closest( '.testimonials ').querySelector( '.testimonials__container' );

        if ( ! container ) {
            console.error( 'container not found', {container, event} );
            return;
        }
        const href = event.target.getAttribute( 'href' );
        const id =  href.substring( 1, href.length );
        
        // console.log({href, id});
        
        const target = container.querySelector(`[id="${id}"]`);

        if ( ! target ) {
            console.error( 'target not found in container', {target, event} );
            return;
        }

        event.preventDefault();
        container.scrollTo( (target.offsetLeft - container.offsetLeft), 0 );

        return false;
    }

    const handleScrolling = ( event ) => {
        const container = event.target;
        const testimonialsElm = container.closest( '.testimonials' );
        const items = container.querySelectorAll( '.testimonial-item' );
        const pageLinks = testimonialsElm.querySelectorAll( '.testimonials__pagination-controls a' );

        pageLinks.forEach((el) => {
            el.setAttribute( 'aria-current', 'false' );
        });

        items.forEach( (el, index) => {
            const hrefToCheck = '#' + el.getAttribute( 'id' );

            if (
                isVisible(el, container) &&
                pageLinks[index] &&
                pageLinks[index].getAttribute( 'href' ) ===  hrefToCheck
            ) {
                pageLinks[index].setAttribute( 'aria-current', 'true' );
                el.setAttribute( 'aria-current', 'true' );
            } else {
                el.setAttribute( 'aria-current', 'false' );
            }
        });
    }

    const isVisible = function (elm, container) {
        const { left } = elm.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        return left === containerRect.left;
    };

    // attach events on containers and controls
    const testimonialContainers = document.querySelectorAll( '.testimonials__container' );

    Array.from( testimonialContainers ).forEach( (el) => {
        el.addEventListener( 'scroll', handleScrolling );
    } );

    const testimonialControlLinkElements = document.querySelectorAll( '.testimonials__pagination-controls a:not(.disabled), .testimonial-item__controls a:not(.disabled)' );

    Array.from( testimonialControlLinkElements ).forEach( (el) => {
        el.addEventListener( 'click', handleOnClick );
    } );

})();
